import React, {useState} from "react";
import translate from "../../../../translate";
import {Dropdown, DropdownElement} from "../../ui/spectre/dropdown";
import {useRevalidator, useRouteLoaderData} from "react-router-dom";
import {Button, ButtonTypes, LinkButton} from "../../ui/spectre/buttons";
import {Column, ColumnGrid} from "../../ui/spectre/grid";
import API from "../../../../api/api";
import Error from "../../ui/error";
import {useNavigate} from "../../../hooks/useNavigate";
import Sizes from "../../ui/spectre/common/sizes";

export default function GroupInviteCreate() {
    const groupData = useRouteLoaderData('group');
    const roles = Object.values(groupData.roles);

    const [selectedRole, setSelectedRole] = useState(null);
    const [error, setError] = useState(null);
    const navigate = useNavigate();
    const revalidator = useRevalidator();

    if(roles.length === 0) {
        return <div className={'bg-warning'}>
            {translate('page/group/invites/create/no_roles')}
            <LinkButton buttonTypes={[ButtonTypes.primary]} href={'../../roles/create'}>{translate('page/group/roles/create')}</LinkButton>
        </div>;
    }

    async function createInvite() {
        /** @type APIResponse */
        const response = await API.post('groups/invites/create', {groupId: groupData.id, roleId: selectedRole});
        if(response?.error) {
            setError(response.errorTranslationKey);
        }
        else {
            revalidator.revalidate();
            navigate('./..');
        }
    }

    return <div>
        <ColumnGrid size={Sizes.md}>
            <Column sizes={[6]}>
                <div className={'pr-2'}>
                    <div>{translate('page/group/invites/create/main_text')}</div>
                    <div className={'text-italic'}>{translate('page/group/invites/create/leader_warning')}</div>
                </div>
            </Column>
            <Column sizes={[6]}>
                <div className={'pl-2'}>
                    <Dropdown initialValue={roles[0].id} onChange={setSelectedRole}>
                        {roles.map(role => <DropdownElement key={role.id} value={role.id}>{role.rolename}</DropdownElement>)}
                    </Dropdown>
                </div>
            </Column>
            {error === null ? null : <Column sizes={[12]}><Error translationKey={error} /></Column>}
            <Column sizes={[12]}>
                <div className={'text-center'}>
                    <Button buttonTypes={[ButtonTypes.primary]} onClick={createInvite}>{translate('page/group/invites/create/create')}</Button>
                </div>
            </Column>
        </ColumnGrid>
    </div>
}
